import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import { AppThemeProvider } from './theme/ThemeContext';

ReactDOM.render(
   <React.StrictMode>
     <AppThemeProvider>
       <App />
     </AppThemeProvider>
   </React.StrictMode>,
   document.getElementById('root')
 );